import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css";

import { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoute from './components/PrivateRoute';
import Login from "./routes/Login";
import Home from "./routes/Home";
import EditTeam from "./routes/EditTeam";
import Courses from "./routes/Courses";
import AboutUs from "./routes/AboutUs";
import FAQ from "./routes/Faq";
import Resources from "./routes/Resources";
import EditResources from "./routes/EditResources";
import EditCourses from './routes/EditCourses';
import Statistics from "./routes/Statistics";
import AppToastContainer from "./components/AppToastContainer";

const App = () => {

  const [toastId, setToastId] = useState(0);
  const [toasts, setToasts] = useState([]);

  function onTriggerMessage(name, content, variant = "light", delay = 3000) {
    const newToasts = [...toasts, { id: toastId, name: name, content: content, variant: variant, delay: delay }];
    setToasts(newToasts);
    setToastId(toastId + 1);
  }

  function onTriggerExpiry(id) {
    const newToasts = toasts.filter(item => item.id !== id);
    setToasts(newToasts);
  }

  return (
    <div className="container-app">
      <AppToastContainer listOfToasts={toasts} onExpiry={onTriggerExpiry} />
      <Router>
        <Routes>
          <Route exact path="/login" element={<Login onTriggerMessage={onTriggerMessage} />} />

          <Route exact path='/' element={<PrivateRoute onTriggerMessage={onTriggerMessage} />}>
            <Route exact path="/" element={<Home />} />
          </Route>
          <Route exact path='/statistics' element={<PrivateRoute onTriggerMessage={onTriggerMessage} />}>
            <Route exact path="/statistics" element={<Statistics onTriggerMessage={onTriggerMessage} />} />
          </Route>
          <Route exact path='/courses' element={<PrivateRoute onTriggerMessage={onTriggerMessage} />}>
            <Route exact path="/courses" element={<Courses />} />
          </Route>
          <Route exact path='/edit-team' element={<PrivateRoute onTriggerMessage={onTriggerMessage} />}>
            <Route exact path="/edit-team" element={<EditTeam onTriggerMessage={onTriggerMessage} />} />
          </Route>
          <Route exact path='/edit-courses' element={<PrivateRoute onTriggerMessage={onTriggerMessage} />}>
            <Route exact path="/edit-courses" element={<EditCourses onTriggerMessage={onTriggerMessage} />} />
          </Route>
          <Route exact path='/about-us' element={<PrivateRoute onTriggerMessage={onTriggerMessage} />}>
            <Route exact path="/about-us" element={<AboutUs />} />
          </Route>
          <Route exact path='/faq' element={<PrivateRoute onTriggerMessage={onTriggerMessage} />}>
            <Route exact path="/faq" element={<FAQ />} />
          </Route>
          <Route exact path='/resources' element={<PrivateRoute onTriggerMessage={onTriggerMessage} />}>
            <Route exact path="/resources" element={<Resources />} />
          </Route>
          <Route exact path='/edit-resources' element={<PrivateRoute onTriggerMessage={onTriggerMessage} />}>
            <Route exact path="/edit-resources" element={<EditResources onTriggerMessage={onTriggerMessage} />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
};

export default App;
